import { View } from './view'

export const Container = View
